import type { ReactNode } from 'react';

// Canonical title for page component cards/panels. One source of truth for
// component-title sizing — change it here to restyle every section title.
// Size matches the original "Incremental Operating Cash Flow by Policy" title.
export function SectionTitle({ children, className }: { children: ReactNode; className?: string }) {
  return <h2 className={`text-lg font-semibold text-gray-900${className ? ` ${className}` : ''}`}>{children}</h2>;
}
